import _objectSpread from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import useSWRV from "swrv";
import { getData, createData } from "@/services/axios";
import { cdate } from "@/utils/cdate";

import { useRoute, useRouter } from 'vue-router/composables';
import { inject, watch, ref, computed } from 'vue';
import { isAuthenticatedKey, meKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
import { useToggle } from '@vueuse/core';
import { useCustomTitle } from '/codebuild/output/src2081543335/src/cocoo_gov/src/composables/useCustomTitle.js';
export default {
  __name: 'ForumEdit',
  setup: function setup(__props) {
    var _editData$value;
    // @ts-check
    var route = useRoute();
    var router = useRouter();
    var isAuthenticated = inject(isAuthenticatedKey);
    var me = inject(meKey);
    watch([me, isAuthenticated], function () {
      var _me$value;
      // 投稿者以外の場合は Dashboard に戻す
      if (isAuthenticated.value && !((_me$value = me.value) !== null && _me$value !== void 0 && (_me$value = _me$value.allow) !== null && _me$value !== void 0 && _me$value.forum_post)) {
        router.push({
          name: "Dashboard"
        });
      }
    }, {
      immediate: true
    });
    var loadingMessage = ref("");
    var estimatedMailCount = ref(0);
    var isCreate = computed(function () {
      return route.name === "ForumCreate";
    });
    var pageTitle = computed(function () {
      return isCreate.value ? "記事作成" : "記事編集";
    });
    var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isShowModal = _useToggle2[0],
      toggleIsShowModal = _useToggle2[1];
    var _useToggle3 = useToggle(false),
      _useToggle4 = _slicedToArray(_useToggle3, 2),
      isShowConfirmModal = _useToggle4[0],
      toggleIsShowConfirmModal = _useToggle4[1];
    var _useSWRV = useSWRV(function () {
        return "forum/".concat(route.params.id);
      }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!route.params.id) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return getData("government_forum/".concat(route.params.id));
            case 1:
              result = _context.v;
              return _context.a(2, result.items);
            case 2:
              return _context.a(2, {});
            case 3:
              return _context.a(2);
          }
        }, _callee);
      })), {
        revalidateOnFocus: false
      }),
      editBaseData = _useSWRV.data;
    var _useSWRV2 = useSWRV(function () {
        return "forum/get_today_mail_count";
      }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var result;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getData("government_forum/get_today_mail_count");
            case 1:
              result = _context2.v;
              return _context2.a(2, result);
          }
        }, _callee2);
      })), {
        revalidateOnFocus: true
      }),
      todayMailCount = _useSWRV2.data;
    watch([editBaseData], function () {
      var _editBaseData$value;
      // 送信済みの場合は Dashboard に戻す
      if (["sent", "failed"].includes((_editBaseData$value = editBaseData.value) === null || _editBaseData$value === void 0 ? void 0 : _editBaseData$value.email_status)) {
        router.push({
          name: "Dashboard"
        });
      }
    }, {
      immediate: true
    });

    /**
     * @returns {{
     *   target: "school" | "guardian";
     *   title: string;
     *   message: string;
     *   expire_on: string;
     *   email_status: string;
     *   is_important: boolean;
     *   school_ids: number[];
     * }}
     */
    var setEditData = function setEditData() {
      var _editBaseData$value2, _route$params, _editBaseData$value3, _route$params2, _editBaseData$value4, _route$params3, _editBaseData$value5, _route$params4, _editBaseData$value6, _route$params5, _editBaseData$value7, _route$params6, _editBaseData$value8;
      return {
        target: ((_editBaseData$value2 = editBaseData.value) === null || _editBaseData$value2 === void 0 ? void 0 : _editBaseData$value2.target) || ((_route$params = route.params) === null || _route$params === void 0 ? void 0 : _route$params.target) || "school",
        title: ((_editBaseData$value3 = editBaseData.value) === null || _editBaseData$value3 === void 0 ? void 0 : _editBaseData$value3.title) || ((_route$params2 = route.params) === null || _route$params2 === void 0 ? void 0 : _route$params2.title) || "",
        message: ((_editBaseData$value4 = editBaseData.value) === null || _editBaseData$value4 === void 0 ? void 0 : _editBaseData$value4.message) || ((_route$params3 = route.params) === null || _route$params3 === void 0 ? void 0 : _route$params3.message) || "",
        expire_on: ((_editBaseData$value5 = editBaseData.value) === null || _editBaseData$value5 === void 0 ? void 0 : _editBaseData$value5.expire_on) || ((_route$params4 = route.params) === null || _route$params4 === void 0 ? void 0 : _route$params4.expire_on) || cdate().add(9, "month").get("year") + "-05-31",
        email_status: ((_editBaseData$value6 = editBaseData.value) === null || _editBaseData$value6 === void 0 ? void 0 : _editBaseData$value6.email_status) || ((_route$params5 = route.params) === null || _route$params5 === void 0 ? void 0 : _route$params5.email_status) || "not_sent",
        is_important: ((_editBaseData$value7 = editBaseData.value) === null || _editBaseData$value7 === void 0 ? void 0 : _editBaseData$value7.is_important) || ((_route$params6 = route.params) === null || _route$params6 === void 0 ? void 0 : _route$params6.is_important) || false,
        // 送信先は複製対象外
        school_ids: ((_editBaseData$value8 = editBaseData.value) === null || _editBaseData$value8 === void 0 || (_editBaseData$value8 = _editBaseData$value8.school) === null || _editBaseData$value8 === void 0 ? void 0 : _editBaseData$value8.map(function (v) {
          return v.id;
        })) || []
      };
    };
    var editData = ref(setEditData());
    var useEmail = ref(((_editData$value = editData.value) === null || _editData$value === void 0 ? void 0 : _editData$value.email_status) !== "not_sent");

    /** @returns {{ grade_ids: number[] }} */
    var setEditOnlyGuardianData = function setEditOnlyGuardianData() {
      var _editBaseData$value9, _route$params7;
      return {
        grade_ids: ((_editBaseData$value9 = editBaseData.value) === null || _editBaseData$value9 === void 0 || (_editBaseData$value9 = _editBaseData$value9.school) === null || _editBaseData$value9 === void 0 ? void 0 : _editBaseData$value9.flatMap(function (v) {
          return JSON.parse(v.pivot.grade_ids);
        })) || (// @ts-ignore
        (_route$params7 = route.params) === null || _route$params7 === void 0 || (_route$params7 = _route$params7.school) === null || _route$params7 === void 0 ? void 0 : _route$params7.flatMap(function (v) {
          return JSON.parse(v.pivot.grade_ids);
        })) || []
      };
    };
    var editOnlyGuardianData = ref(setEditOnlyGuardianData());
    var setAttachmentList = function setAttachmentList() {
      var _editBaseData$value0;
      return (_editBaseData$value0 = editBaseData.value) !== null && _editBaseData$value0 !== void 0 && (_editBaseData$value0 = _editBaseData$value0.attachment) !== null && _editBaseData$value0 !== void 0 && _editBaseData$value0.length ? editBaseData.value.attachment : [undefined];
    };

    /** @type {Ref<File[] | any[]>} */
    var attachmentList = ref(setAttachmentList());
    watch(function () {
      return editOnlyGuardianData.value.grade_ids;
    }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            if (!(editOnlyGuardianData.value.grade_ids && editOnlyGuardianData.value.grade_ids.length > 0)) {
              _context3.n = 2;
              break;
            }
            _context3.n = 1;
            return getData("government_forum/get_estimated_mail_count", {
              grade_ids: editOnlyGuardianData.value.grade_ids
            });
          case 1:
            estimatedMailCount.value = _context3.v;
            _context3.n = 3;
            break;
          case 2:
            estimatedMailCount.value = 0;
            return _context3.a(2);
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    })), {
      immediate: true
    });
    watch(estimatedMailCount, function () {
      if (estimatedMailCount.value > 0) {
        validateMailCount(true);
      }
    }, {
      immediate: true
    });
    var remainingMailCount = computed(function () {
      return Number(todayMailCount.value.forum_mail_limit) - Number(todayMailCount.value.current_total_recipients_count);
    });
    watch(editBaseData, function () {
      editData.value = setEditData();
      editOnlyGuardianData.value = setEditOnlyGuardianData();
      attachmentList.value = setAttachmentList();
    });
    var updeteSchoolIds = function updeteSchoolIds(input) {
      editData.value.school_ids = input;
    };
    var updeteGradeIds = function updeteGradeIds(input) {
      editOnlyGuardianData.value.grade_ids = input;
    };
    var _useToggle5 = useToggle(),
      _useToggle6 = _slicedToArray(_useToggle5, 2),
      isShowCancelConfirmModal = _useToggle6[0],
      toggleIsShowCancelConfirmModal = _useToggle6[1];
    var removeSelectSchool = function removeSelectSchool() {
      editData.value.school_ids = [];
      editOnlyGuardianData.value.grade_ids = [];
      toggleIsShowCancelConfirmModal(false);
    };
    var modalMessage = ref({
      title: "",
      message: ""
    });
    var _useToggle7 = useToggle(),
      _useToggle8 = _slicedToArray(_useToggle7, 2),
      isShowMessageModal = _useToggle8[0],
      toggleIsShowMessageModal = _useToggle8[1];
    var closeMessageModal = function closeMessageModal() {
      toggleIsShowMessageModal(false);
      router.push({
        name: "ForumIndex"
      });
    };
    var resetError = function resetError() {
      return {
        school_ids: "",
        title: "",
        message: "",
        mailCount: ""
      };
    };
    var error = ref(resetError());
    var validateTitle = function validateTitle(valid) {
      error.value.title = "";
      if (!editData.value.title) {
        error.value.title = "記事のタイトルを入力してください。";
        valid = false;
      }
      return valid;
    };
    var validateMessage = function validateMessage(valid) {
      error.value.message = "";
      if (!editData.value.message) {
        error.value.message = "メッセージ本文を入力してください。";
        valid = false;
      }
      return valid;
    };
    var validateMailCount = function validateMailCount(valid) {
      error.value.mailCount = "";
      if (useEmail.value && estimatedMailCount.value > remainingMailCount.value) {
        error.value.mailCount = "本日の送信上限数を超過しています。";
        valid = false;
      }
      return valid;
    };
    var validateForum = function validateForum() {
      error.value = resetError();
      var valid = true;
      if (!editData.value.school_ids.length) {
        error.value.school_ids = "送信先を入力してください。";
        valid = false;
      }
      valid = validateTitle(valid);
      valid = validateMessage(valid);
      valid = validateMailCount(valid);
      return valid;
    };
    var _useToggle9 = useToggle(),
      _useToggle0 = _slicedToArray(_useToggle9, 2),
      isDelete = _useToggle0[0],
      toggleIsDelete = _useToggle0[1];
    var handleMailPreview = function handleMailPreview() {
      if (useEmail.value) {
        validateForum() ? toggleIsShowConfirmModal(true) : false;
      } else {
        createEditForum();
      }
    };
    var createEditForum = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var payload, formData, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (validateForum()) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, false);
            case 1:
              /**
               * @type {typeof editData.value & { email_status: string } & Partial<typeof editOnlyGuardianData.value> & {
               *     attachment?: File;
               *     file_name?: string;
               *     delete?: boolean;
               *   }}
               */
              payload = _objectSpread({}, editData.value);
              if (editData.value.email_status === "not_sent") {
                // メール送信未使用のときのみ、送信に切り替えることを許可
                payload = _objectSpread(_objectSpread({}, payload), {}, {
                  email_status: useEmail.value ? "pending" : "not_sent"
                });
              }
              if (editData.value.target === "guardian") {
                payload = _objectSpread(_objectSpread({}, payload), editOnlyGuardianData.value);
              }
              if (attachmentList.value[0] && attachmentList.value[0] instanceof File) {
                payload = _objectSpread(_objectSpread({}, payload), {}, {
                  attachment: attachmentList.value[0],
                  file_name: attachmentList.value[0].name
                });
              } else if (isDelete.value) {
                payload = _objectSpread(_objectSpread({}, payload), {}, {
                  delete: isDelete.value
                });
              }
              formData = new FormData();
              Object.entries(payload).forEach(function (_ref5) {
                var _ref6 = _slicedToArray(_ref5, 2),
                  key = _ref6[0],
                  value = _ref6[1];
                if (Array.isArray(value)) {
                  value.forEach(function (v2) {
                    formData.append(key + "[]", String(v2));
                  });
                } else if (typeof value === "boolean") {
                  formData.append(key, String(Number(value)));
                } else {
                  formData.append(key, value);
                }
              });
              _context4.p = 2;
              if (!isCreate.value) {
                _context4.n = 4;
                break;
              }
              loadingMessage.value = "掲示板を登録しています。";
              _context4.n = 3;
              return createData("government_forum", formData);
            case 3:
              modalMessage.value = {
                title: "投稿完了",
                message: "記事の投稿が完了しました"
              };
              _context4.n = 6;
              break;
            case 4:
              // 素のputではformdataが使えなかったのでmethodを指定しつつpostする
              formData.append("_method", "put");
              loadingMessage.value = "掲示板を更新しています。";
              _context4.n = 5;
              return createData("government_forum/".concat(route.params.id), formData);
            case 5:
              modalMessage.value = {
                title: "編集完了",
                message: "記事を編集しました"
              };
            case 6:
              loadingMessage.value = "";
              toggleIsShowMessageModal(true);
              _context4.n = 8;
              break;
            case 7:
              _context4.p = 7;
              _t = _context4.v;
              console.log(_t);
              loadingMessage.value = "掲示板の登録に失敗しました。しばらく経ってからお試しください";
            case 8:
              return _context4.a(2);
          }
        }, _callee4, null, [[2, 7]]);
      }));
      return function createEditForum() {
        return _ref4.apply(this, arguments);
      };
    }();
    useCustomTitle(pageTitle);
    return {
      __sfc: true,
      route: route,
      router: router,
      isAuthenticated: isAuthenticated,
      me: me,
      loadingMessage: loadingMessage,
      estimatedMailCount: estimatedMailCount,
      isCreate: isCreate,
      pageTitle: pageTitle,
      isShowModal: isShowModal,
      toggleIsShowModal: toggleIsShowModal,
      isShowConfirmModal: isShowConfirmModal,
      toggleIsShowConfirmModal: toggleIsShowConfirmModal,
      editBaseData: editBaseData,
      todayMailCount: todayMailCount,
      setEditData: setEditData,
      editData: editData,
      useEmail: useEmail,
      setEditOnlyGuardianData: setEditOnlyGuardianData,
      editOnlyGuardianData: editOnlyGuardianData,
      setAttachmentList: setAttachmentList,
      attachmentList: attachmentList,
      remainingMailCount: remainingMailCount,
      updeteSchoolIds: updeteSchoolIds,
      updeteGradeIds: updeteGradeIds,
      isShowCancelConfirmModal: isShowCancelConfirmModal,
      toggleIsShowCancelConfirmModal: toggleIsShowCancelConfirmModal,
      removeSelectSchool: removeSelectSchool,
      modalMessage: modalMessage,
      isShowMessageModal: isShowMessageModal,
      toggleIsShowMessageModal: toggleIsShowMessageModal,
      closeMessageModal: closeMessageModal,
      resetError: resetError,
      error: error,
      validateTitle: validateTitle,
      validateMessage: validateMessage,
      validateMailCount: validateMailCount,
      validateForum: validateForum,
      isDelete: isDelete,
      toggleIsDelete: toggleIsDelete,
      handleMailPreview: handleMailPreview,
      createEditForum: createEditForum,
      cdate: cdate
    };
  }
};